import { render, staticRenderFns } from "./ChangeDetail.vue?vue&type=template&id=8d1f9766&scoped=true"
import script from "./ChangeDetail.vue?vue&type=script&lang=js"
export * from "./ChangeDetail.vue?vue&type=script&lang=js"
import style0 from "./ChangeDetail.vue?vue&type=style&index=0&id=8d1f9766&prod&lang=scss&scoped=true"
import style1 from "./ChangeDetail.vue?vue&type=style&index=1&id=8d1f9766&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1f9766",
  null
  
)

export default component.exports